// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"association-task-form_tooltip__1V5EA","tooltiptext":"association-task-form_tooltiptext__1flTs"};